module.exports = __webpack_public_path__ + "assets/img/1811.905e283a.svg";